exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3.modal-title{font-size:22px;margin:0;font-weight:600;color:#4c4c4c;margin-bottom:-10px}.attributesTab{padding:0}.attributesTab .well-sm{padding:10px 0px}.attributesTab pre{background-color:#e9eff5}.btn-group-1 .btn{margin-right:0}.export-modal{border:1px dashed #e91e63;color:#e91e63;font-style:italic;padding:2px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/schema/shared/preview-popup.scss
// module id = 1193
// module chunks = 0 2